import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/waehrungen-ware/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierGoodCurrency"
      returnRoute="/auswahlfelder/dossierGoodCurrency"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierGoodCurrencyRoute = Route;
